"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopClient = void 0;
var client_1 = require("./client");
Object.defineProperty(exports, "ShopClient", { enumerable: true, get: function () { return client_1.ShopClient; } });
//# sourceMappingURL=index.js.map